"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getLogoType = getLogoType;
exports.setLogo = setLogo;
exports.setLogoPosition = setLogoPosition;
exports.getLogoPositionFromTemplate = getLogoPositionFromTemplate;
exports.deleteLogo = deleteLogo;
exports.normalizeLogoObject = normalizeLogoObject;
exports.setLogoMask = setLogoMask;
exports.setLogoImageScale = setLogoImageScale;
exports.setLogoBackground = setLogoBackground;

var _color = _interopRequireDefault(require("color"));

var _colorUtils = require("./color-utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getLogoType(lottie) {
  return lottie.data.logo.type;
}

function setLogo(lottie, logo) {
  const {
    url,
    id
  } = logo;
  const logoData = {
    type: 'image',
    value: url,
    id,
    style: { ...lottie.data.logo.style,
      imageOriginWidth: logo.width,
      imageOriginHeight: logo.height
    }
  };
  lottie.data.logo = { ...lottie.data.logo,
    ...logoData
  };
  return lottie;
}

function deleteLogo(lottie) {
  lottie.data.logo = { ...lottie.data.logo,
    ...{
      type: 'placeholder',
      value: '',
      id: null
    }
  };
  return lottie;
} // set logo size and position


function setLogoPosition(lottie, rect) {
  // get current logo rect before change
  if (lottie.data.logo.style) {
    const {
      width,
      height,
      left,
      top
    } = lottie.data.logo.style;
    lottie.data.logo.style = { ...lottie.data.logo.style,
      width: rect.width || width,
      height: rect.height || height,
      left: rect.x || left,
      top: rect.y || top
    };
  }

  return lottie;
}

function getLogoPositionFromTemplate(lottie, templateData) {
  const {
    data
  } = lottie;
  const {
    template
  } = templateData;
  const {
    position,
    size
  } = template.logo[data.textAlign];
  return {
    width: size.width,
    height: size.width,
    x: position.x,
    y: position.y
  };
}

function normalizeLogoObject(logo) {
  const {
    type,
    id,
    value,
    style
  } = logo;

  if (type === 'image') {
    const {
      left,
      top,
      height,
      width,
      shape,
      backgroundColor,
      imageWidth
    } = style;
    return {
      type,
      id,
      url: value,
      rect: {
        height: height || null,
        x: left || null,
        y: top || null,
        width: width || null
      },
      mask: shape,
      imageScale: parseFloat(imageWidth) / 100.0,
      backgroundColor: backgroundColor ? (0, _colorUtils.colorStringToObject)(backgroundColor) : null
    };
  }

  return {
    type: 'placeholder'
  };
}

function setLogoMask(lottie, mask) {
  lottie.data.logo.style = { ...lottie.data.logo.style,
    shape: mask
  };
  return lottie;
}

function setLogoImageScale(lottie, scale) {
  const convert = `${parseInt(scale * 100.0, 10)}%`;
  lottie.data.logo.style = { ...lottie.data.logo.style,
    imageWidth: convert,
    imageHeight: convert
  };
  return lottie;
}

function setLogoBackground(lottie, bgcolor) {
  lottie.data.logo.style = { ...lottie.data.logo.style,
    backgroundColor: (0, _color.default)(bgcolor).rgb().string()
  };
  return lottie;
}